module.exports = __webpack_public_path__ + "assets/img/jiachi_5013_4.8fd9618f.jpg";